import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { SettingsService } from '../../../services/settings.service';

interface SystemSettings {
  siteName: string;
  supportEmail: string;
  maxConcurrentChats: number;
  sessionTimeout: number;
  enableNotifications: boolean;
  enableAnalytics: boolean;
  maintenanceMode: boolean;
  geminiApiKey: string;
  geminiModel: string;
  maxTokens: number;
  temperature: number;
}

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  settings: SystemSettings = {
    siteName: 'MHealth Chatbot Admin',
    supportEmail: 'support@mhealth.ng',
    maxConcurrentChats: 100,
    sessionTimeout: 30,
    enableNotifications: true,
    enableAnalytics: true,
    maintenanceMode: false,
    geminiApiKey: '••••••••••••••••',
    geminiModel: 'gemini-2.5-flash',
    maxTokens: 1000,
    temperature: 0.7
  };

  activeTab: string = 'general';
  saveSuccess: boolean = false;
  saveError: boolean = false;

  constructor(
    private router: Router,
    private settingsService: SettingsService
  ) { }

  ngOnInit(): void {
    this.loadSettings();
  }

  loadSettings(): void {
    this.settingsService.getSettings().subscribe({
      next: (json) => {
        if (json.success && json.settings) {
          this.settings.geminiModel = json.settings.geminiModel || this.settings.geminiModel;
          this.settings.maxTokens = json.settings.maxTokens || this.settings.maxTokens;
          this.settings.temperature = json.settings.temperature || this.settings.temperature;
          if (json.settings.geminiApiKey) this.settings.geminiApiKey = json.settings.geminiApiKey;
        }
      },
      error: (err) => console.warn('Failed to fetch settings:', err)
    });
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  saveSettings(): void {
    this.settingsService.updateSettings(this.settings).subscribe({
      next: (json) => {
        if (json && json.success) {
          this.saveSuccess = true;
          this.saveError = false;
          this.loadSettings();
          setTimeout(() => { this.saveSuccess = false; }, 3000);
        } else {
          this.saveError = true;
          this.saveSuccess = false;
        }
      },
      error: (e) => {
        this.saveError = true;
        this.saveSuccess = false;
        console.error(e);
      }
    });
  }

  resetSettings(): void {
    if (confirm('Are you sure you want to reset all settings to default values?')) {
      this.settings = {
        siteName: 'MHealth Chatbot Admin',
        supportEmail: 'support@mhealth.ng',
        maxConcurrentChats: 100,
        sessionTimeout: 30,
        enableNotifications: true,
        enableAnalytics: true,
        maintenanceMode: false,
        geminiApiKey: '••••••••••••••••',
        geminiModel: 'gemini-2.5-flash',
        maxTokens: 1000,
        temperature: 0.7
      };
    }
  }

  goBack(): void {
    this.router.navigate(['/admin/dashboard']);
  }
}
